import { FC, Fragment, useEffect, useState } from "react";
import { RootState } from "../../../app/Store";
import { useSelector, useDispatch } from "react-redux";
import { getLotteryList } from "../../../features/lotteryListSlice";
import ViewHeader from "../../../components/ViewHeader/ViewHeader";
import TrafficLight from "../../../components/TrafficLight/TrafficLight";
import EmptyTableView from "../../../components/EmptyTableView/EmptyTableView";
import Button from "../../../components/UI/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  transformDate,
  tablePagination,
  searchTableData,
  sortTableValues,
} from "../../../Utility/Utility";
import TableHeaderComponent from "../../../components/TableHeader/TableHeader";
import TableFooter from "../../../components/TableFooter/TableFooter";
import JsonToCsv from "../../../components/JSONToCSV/JsonToCsv";
import {
  BreadcrumbSection,
  TableWrapper,
  Table,
  Th,
  ContentSection,
  Tbody,
  NumberOfUsers,
  TabMenuContainer,
  MenuOption,
  DropdownContainer,
  DropdownOptionsContainer,
  DropdownOption,
  DropdownActiveOption,
  SearchSectionContainer,
  Input,
  LotteryOptionsList,
  LotteryOption,
  LotteryTypeTitle,
  Live,
  Upcoming,
} from "./StyledLottery";
import { adminRouts } from "../../../routs";
import { RedDot } from "../../../components/TrafficLight/StyledTrafficLight";

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
}

interface TableHeaders {
  label: string;
  isSortRequired: boolean;
  isAscSorted: boolean;
  id: string;
}

class TableHeader {
  constructor(
    public label: string,
    public isSortRequired: boolean,
    public isAscSorted: boolean,
    public isDscSorted: boolean,
    public id: string
  ) {}
}

let tableHeaders = [
  new TableHeader("Id", true, true, false, "lotteryGameId"),
  new TableHeader("Reward", true, false, false, "rewardAmount"),
  new TableHeader("Start Date", false, false, false, "Start_date"),
  new TableHeader("End Date", false, false, false, "End_date"),
  new TableHeader("Amount", true, false, false, "amountCollected"),
  new TableHeader("Users Joined", false, false, false, "noOfUsersJoined"),
  new TableHeader("Status", false, false, false, "Status"),
  new TableHeader("TicketNo", false, false, false, "winnerTicketNo"),
  new TableHeader("winnerUserId", false, false, false, "winnerUserId"),
  new TableHeader("Role", false, false, false, "winnerRole"),
];

let tabMenuViewList = [
  {
    label: "Live Lotteries",
    id: "currentLotteries_3",
    queryParam: "C",
    isActive: true,
    isSerarchViewActive: false,
  },
  {
    label: "Upcomming Lotteries",
    id: "pendingLotteries_3",
    queryParam: "U",
    isActive: false,
    isSerarchViewActive: false,
  },
  {
    label: "Winner Lotteries",
    id: "winnerLotteries_2",
    queryParam: "E",
    isActive: false,
    isSerarchViewActive: false,
  },

  {
    label: "Cancelled Lotteries",
    id: "cancelledLotteries_3",
    queryParam: "D",
    isActive: false,
    isSerarchViewActive: false,
  },
  {
    label: "All",
    id: "all_1",
    queryParam: "A",
    isActive: false,
    isSerarchViewActive: true,
  },
];

const LotteryList: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tabMenu, setTabMenu] = useState(tabMenuViewList);

  const [tableHeaderValues, setHeaderValues] = useState(tableHeaders);

  const [originalResponse, setOriginalResponse] = useState<any>([]);
  const [responseData, setResponseData] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalResponseLength, setResponseLength] = useState(0);
  const [tableSearch, setSearch] = useState("");

  let mainList = useSelector(
    (state: RootState) => state.lotteryList.lotteryList
  );
  let lotteryList = [...mainList].reverse();
  console.log(lotteryList);

  useEffect(() => {
    getLotteryData(tabMenu);
  }, []);

  useEffect(() => {
    if (lotteryList.length > 0) {
      setResponseLength(lotteryList.length);
      setOriginalResponse(lotteryList);
      let pagedResponse = tablePagination(lotteryList, 1);
      if (pagedResponse.isValidResponse) {
        setResponseData(pagedResponse.data);
      }
    } else {
      setResponseData([]);
    }
  }, [mainList]);

  const redirectToLotteryDetail = (lotteryId: number): void => {
    navigate(`/admin/lottery/view/${lotteryId}`, { state: lotteryId });
  };
  const redirectTouserDetailView = (winnerUserId: any) => {
    navigate(adminRouts.viewUser(winnerUserId));
    // console.log(coinId);
  };

  const updateTabMenuOption = (selectedMenuId) => {
    let updatedMenuArray = tabMenu.map((menuObj) => {
      return {
        ...menuObj,
        isActive: menuObj.id === selectedMenuId,
      };
    });
    getLotteryData(updatedMenuArray);
    setTabMenu(updatedMenuArray);
  };

  const getLotteryData = (tabObj) => {
    let selectedObj = tabObj.filter((tabObj) => {
      return tabObj.isActive;
    })[0];

    dispatch(getLotteryList(selectedObj.queryParam));
  };

  const updatePageNumber = (pageNumber) => {
    if (originalResponse.length > 0) {
      let pagedResponse = tablePagination(originalResponse, pageNumber);
      if (pagedResponse.isValidResponse) {
        setPageNumber(pagedResponse.pageNumber);
        setResponseData(pagedResponse.data);
      }
    }
  };

  const sortTable = (id: string, isSortAsc: boolean) => {
    let sortedArray: any = sortTableValues(originalResponse, id, !isSortAsc);
    setPageNumber(1);
    setOriginalResponse(sortedArray);
    let pagedResponse = tablePagination(sortedArray, 1);
    setResponseData(pagedResponse.data);
    let updatedTableHeaders: any = [];
    for (let headerObj of tableHeaderValues) {
      if (headerObj.id === id) {
        let updatedObj = {
          ...headerObj,
          isAscSorted: !isSortAsc,
          isDscSorted: isSortAsc,
        };
        updatedTableHeaders.push(updatedObj);
      } else {
        let updatedObj = {
          ...headerObj,
          isAscSorted: false,
          isDscSorted: false,
        };
        updatedTableHeaders.push(updatedObj);
      }
    }
    setHeaderValues(updatedTableHeaders);
  };

  const setTableSearchValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const triggerSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      // console.log(originalResponse,tableSearch)
      let searchResponse = searchTableData(originalResponse, tableSearch);
      if (searchResponse.length > 0) {
        setResponseData(searchResponse);
        setPageNumber(1);
        setResponseLength(searchResponse.length);
      }
    }
  };

  let tabMenuView = tabMenu.map((menuObj) => {
    return (
      <MenuOption
        onClick={() => {
          updateTabMenuOption(menuObj.id);
        }}
        isActive={menuObj.isActive}
        key={menuObj.id}
      >
        {menuObj.label}
      </MenuOption>
    );
  });

  let lotteries = responseData.map((lotteryObj: any) => {
    let lotterIdBtn = (
      <Button
        title={`${lotteryObj.lotteryGameId}`}
        btnSize={ButtonSize.sm}
        btnVariant={ButtonVariant.primaryLink}
        clicked={() => {
          redirectToLotteryDetail(lotteryObj.lotteryGameId);
        }}
      />
    );
    let userIdBtn = (
      <Button
        title={`${
          lotteryObj?.winnerUserId !== null ? lotteryObj?.winnerUserId : ""
        }`}
        btnSize={ButtonSize.sm}
        btnVariant={ButtonVariant.primaryLink}
        clicked={() => {
          redirectTouserDetailView(lotteryObj?.winnerUserId);
        }}
      />
    );

    let lotteryStatusTag =
      lotteryObj.lotteryGameStatus === "C" ? (
        <Live>Live</Live>
      ) : lotteryObj.lotteryGameStatus === "U" ? (
        <Upcoming>Not Live</Upcoming>
      ) : lotteryObj.lotteryGameStatus === "E" ? (
        <Live>Winner</Live>
      ) : null;

    return (
      <tr>
        <td>{lotterIdBtn}</td>
        {/* <td>&#x24;{lotteryObj.rewardAmount ? lotteryObj.rewardAmount : 0}</td> */}
        <td>
          {lotteryObj?.rewardType === "G" ? (
            lotteryObj?.rewardGiftName
          ) : (
            <span>
              &#x24;{lotteryObj.rewardAmount ? lotteryObj.rewardAmount : 0}
            </span>
          )}
        </td>
        <td>{transformDate(lotteryObj.lotteryGameStartDate)}</td>
        <td>{transformDate(lotteryObj.lotteryGameEndDate)}</td>
        <td>
          {lotteryObj?.rewardType === "M" ? (
            <TrafficLight
              maxAmount={lotteryObj.rewardAmount ? lotteryObj.rewardAmount : 0}
              compareAmount={
                lotteryObj.amountCollected ? lotteryObj.amountCollected : 0
              }
            />
          ) : (
            <RedDot/>
          )}
          &#x24;{lotteryObj.amountCollected ? lotteryObj.amountCollected : 0}
        </td>
        <td>
          <NumberOfUsers>{lotteryObj.noOfUsersJoined}</NumberOfUsers>
        </td>
        <td>{lotteryStatusTag}</td>
        <td>
          {lotteryObj.lotteryGameStatus === "E"
            ? lotteryObj?.winnerTicketNo
            : "-"}
        </td>
        <td>{lotteryObj.lotteryGameStatus === "E" ? userIdBtn : "-"}</td>
        <td>
          {lotteryObj.lotteryGameStatus === "E" ? lotteryObj?.winnerRole : "-"}
        </td>
      </tr>
    );
  });

  return (
    <Fragment>
      <BreadcrumbSection>
        <ViewHeader
          title={"Lottery"}
          isNeedCreateButton={true}
          btnText={"Test button"}
          routePath={"/"}
        />
        <JsonToCsv data={mainList} fileLabel={"games"} />
      </BreadcrumbSection>
      <ContentSection>
        <SearchSectionContainer>
          <Input
            value={tableSearch}
            onKeyDown={triggerSearch}
            onChange={setTableSearchValue}
            placeholder={"Search"}
          />
        </SearchSectionContainer>
        <TableWrapper>
          <TabMenuContainer>{tabMenuView}</TabMenuContainer>
          <Table>
            <thead>
              <TableHeaderComponent
                headers={tableHeaderValues}
                onToggleSort={sortTable}
              />
            </thead>
            <Tbody>{lotteries}</Tbody>
          </Table>
          {responseData.length === 0 && <EmptyTableView />}
          <TableFooter
            totalCount={totalResponseLength}
            currentPageNumber={pageNumber}
            updatePageNumber={updatePageNumber}
          />
        </TableWrapper>
      </ContentSection>
    </Fragment>
  );
};

export default LotteryList;
